import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// jQuery
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import moment from 'moment';
window.moment = moment;


import 'daterangepicker/daterangepicker.css';

import 'daterangepicker';

import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { faUser } from '@fortawesome/free-solid-svg-icons';

library.add(faUser);


import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faDownload, faUserCircle, faSignOutAlt, faFileCsv, faPlay, faPause, faPauseCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


library.add(faDownload, faUserCircle, faSignOutAlt, faFileCsv, faPlay, faPause, faPauseCircle);
import { faUsers,faTable,faLocationCrosshairs,faMobileScreen,faComputer, faChartPie, faUndo, faUserShield, faCogs, faChartBar, faPhone, faCoins, faCalendarWeek, faFilter } from '@fortawesome/free-solid-svg-icons';

library.add(faTable,faComputer, faChartPie,faLocationCrosshairs,faMobileScreen, faUsers, faUserShield, faCogs, faChartBar, faUndo, faPhone, faCoins, faCalendarWeek, faFilter);

const app = createApp(App);



app.component('Multiselect', Multiselect);
app.component('font-awesome-icon', FontAwesomeIcon);

app.use(router);
app.mount('#app');

import VueApexCharts from "vue3-apexcharts";

app.component("apexchart", VueApexCharts);
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
library.add(faCheckCircle, faTimesCircle);


import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
app.component('Datepicker', VueDatePicker);


